import React from 'react';
import { urlFor } from '../sanityClient';

// Renders the full performance page layout (poster + description panel + gallery + video).
// The `performance` prop is the fully-resolved Sanity performance document.
export default function PerformanceHero({ performance: p }) {
  if (!p) return null;
  const lang = localStorage.getItem('language') || 'arm';

  const t = (field) => (p[field] ? (p[field][lang] || p[field].en || '') : '');

  const posterSrc   = p.poster   ? urlFor(p.poster).width(600).url()  : '';
  const photos      = p.photos   || [];
  const videoUrl    = p.videoUrl || '';
  const photoCredit = t('photoCredit');
  const nextSlug    = p.nextSlug || '';

  return (
    <>
      {/* Breadcrumb */}
      <div className='breadcrumb-row d-none d-lg-block'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              <nav aria-label='breadcrumb'>
                <ol className='breadcrumb bg-transparent px-0'>
                  <li className='breadcrumb-item'><a href='/'>Home</a></li>
                  <li className='breadcrumb-item active'>{t('title')}</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Hero row: poster + description */}
      <section className='main-container performance-page-container'>
        <div className='container-fluid'>
          <div className='row'>
            {/* Poster */}
            <div className='col-lg-5 col-md-12 poster-column'>
              <div className='white-decoration'>
                <img src='images/white-decoration.svg' alt='decoration' className='img-fluid' />
              </div>
              {posterSrc && (
                <img src={posterSrc} alt={t('title')} className='img-fluid poster-img' />
              )}
            </div>

            {/* Description */}
            <div className='col-lg-7 col-md-12 description-column'>
              <div className='performance-info'>
                <h1 className='performance-title'>{t('title')}</h1>
                {t('subtitle') && <h2 className='performance-subtitle'>{t('subtitle')}</h2>}
                <div
                  className='performance-description'
                  dangerouslySetInnerHTML={{ __html: t('description') }}
                />
                {t('premiereDate') && (
                  <p className='premiere-date'>{t('premiereDate')}</p>
                )}
                {t('cast') && (
                  <div className='cast-section'>
                    <pre className='cast-text'>{t('cast')}</pre>
                  </div>
                )}

                {/* Next/Prev navigation */}
                {nextSlug && (
                  <div className='performance-nav d-none d-lg-block'>
                    <a href={`/${nextSlug}`} className='next-performance-link'>
                      <img src='images/right-arrow.svg' alt='next' className='img-fluid' />
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery slider */}
      {photos.length > 0 && (
        <section className='photo-gallery-section'>
          <div id='performanceGallery' className='slider-for'>
            {photos.map((photo, i) => {
              const src = urlFor(photo).width(900).url();
              return (
                <div key={i}>
                  <img src={src} alt={`gallery-${i}`} className='img-fluid gallery-main-img' />
                </div>
              );
            })}
          </div>
          <div className='slider-nav gallery-thumbs'>
            {photos.map((photo, i) => {
              const src = urlFor(photo).width(200).url();
              return (
                <div key={i}>
                  <img src={src} alt={`thumb-${i}`} className='img-fluid gallery-thumb' />
                </div>
              );
            })}
          </div>
          {photoCredit && (
            <p className='photo-credit text-center mt-2'>{photoCredit}</p>
          )}
        </section>
      )}

      {/* YouTube embed */}
      {videoUrl && (
        <section className='video-section text-center py-4'>
          <iframe
            src={videoUrl}
            title='performance video'
            width='100%'
            height='500'
            frameBorder='0'
            allow='autoplay; encrypted-media'
            allowFullScreen
          />
        </section>
      )}

      {/* Mobile next link */}
      {nextSlug && (
        <div className='d-lg-none mobile-next-link text-center py-3'>
          <a href={`/${nextSlug}`}>
            <img src='images/right-arrow.svg' alt='next' className='img-fluid' style={{ width: 40 }} />
          </a>
        </div>
      )}
    </>
  );
}
